export enum AccountingTab {
  ChartOfAccounts = 'chart-of-accounts',
  DetailedMappings = 'detailed-mappings',
}

export const accountingTabTitles = {
  [AccountingTab.ChartOfAccounts]: 'Chart of Accounts',
  [AccountingTab.DetailedMappings]: 'Detailed Mappings',
}
